var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCorner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33344 11.3334C1.16277 11.3334 0.992103 11.2685 0.862326 11.1378C0.601881 10.8774 0.601881 10.4552 0.862326 10.1947L9.97345 1.08449C10.2339 0.824049 10.6561 0.824049 10.9166 1.08449C11.177 1.34494 11.177 1.76717 10.9166 2.02761L1.80455 11.1378C1.67477 11.2676 1.5041 11.3334 1.33344 11.3334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6669 8.67564C10.2989 8.67564 10.0003 8.37697 10.0003 8.00898V2.00008H3.99137C3.62337 2.00008 3.32471 1.70141 3.32471 1.33341C3.32471 0.965415 3.62337 0.666748 3.99137 0.666748H10.6669C11.0349 0.666748 11.3336 0.965415 11.3336 1.33341V8.00898C11.3336 8.37697 11.0349 8.67564 10.6669 8.67564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCorner);
export default __webpack_public_path__ + "static/media/arrow-corner.e6775e2fb0f1b5a456057c4a5107af81.svg";
export { ForwardRef as ReactComponent };